<template>
  <div>
    <div
      style="width: 100%; height: 350px; background-color: #0f0b26; color: white"
      @click="routerTo"
    >
      <div
        style="
          color: white;
          text-align: center;
          background-color: #0f0b26;
          font-weight: 800;
        "
      >
        本月人流变化
      </div>
      <div
        style="
          display: flex;
          text-align: center;
          margin: 40px 0;
          justify-content: space-between;
        "
      >
        <div
          style="width: 49%; padding: 20px; font-size: 40px; background-color: #00a8fb"
        >
          今日入住{{ list.今日入住 }}人
        </div>
        <div
          style="width: 49%; padding: 20px; font-size: 40px; background-color: #fcb300"
        >
          本月入住{{ list.本月入住 }}人
        </div>
      </div>
      <div style="display: flex; text-align: center; justify-content: space-between">
        <div
          style="width: 49%; padding: 20px; font-size: 40px; background-color: #26e9c5"
        >
          本月访客{{ list.本月访客 }}人
        </div>
        <div
          style="width: 49%; padding: 20px; font-size: 40px; background-color: #ff6c83"
        >
          本月退房{{ list.本月退房 }}人
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["jrqk", "isTrue"],
  data() {
    return {
      list: {},
    };
  },
  watch: {
    isTrue(val) {
      if (val == true) {
        this.getJrqk();
      }
    },
  },
  methods: {
    routerTo() {
      this.$router.push({ path: "/index/apartment/customerInformation/customerRoom" });
    },
    getJrqk() {
      let myChart = this.echarts.init(document.getElementById("tb2"), "dark");

      setTimeout(() => {
        this.$http.get("/api/screen/getPeopleChange").then((res) => {
          console.log(res);
          this.list = res.data.data;
        });
        var option = {
          backgroundColor: "#12215d",
          title: {
            text: "今日情况",
            // subtext: '纯属虚构',
            left: "center",
          },
          tooltip: {
            trigger: "item",
          },
          toolbox: {
            feature: {
              saveAsImage: {},
            },
          },
          legend: {
            orient: "vertical",
            left: "left",
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: "50%",
              data: [
                {
                  value: this.jrqk[0],
                  name: "人才入住",
                },
                {
                  value: this.jrqk[1],
                  name: "访客申请",
                },
                {
                  value: this.jrqk[2],
                  name: "退房申请",
                },
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
        myChart.setOption(option);
      }, 100);
    },
  },
};
</script>

<style scoped="scoped"></style>
